import { SrStepsHeaderComponent } from './sr-steps-header/sr-steps-header.component';
import { SrRecipientsComponent } from './sr-recipients/sr-recipients.component';
import { SrRecipientDetailsComponent } from './sr-recipient-details/sr-recipient-details.component';
import { SrRecipientsOverviewComponent } from './sr-recipients-overview/sr-recipients-overview.component';
import { SrSubmitterComponent } from './sr-submitter/sr-submitter.component';
import { SrRecipientComponent } from './sr-recipient/sr-recipient.component';
import { SrSendDateComponent } from './sr-send-date/sr-send-date.component';

export const SrComponents = [
    SrStepsHeaderComponent,
    SrRecipientComponent,
    SrRecipientsComponent,
    SrRecipientDetailsComponent,
    SrRecipientsOverviewComponent,
    SrSubmitterComponent,
    SrSendDateComponent
];
